import { getRouteObjectList, withLayout } from '../router/util/router.helper'
import { RouteObjectList } from '../router/model/Route'
import { companyPageIds } from '../router/model/RouteId'
import { RouterLayout } from '../router/component/layout/RouterLayout'

export const CompanyPageRoutes: RouteObjectList = [
  withLayout({
    layout: <RouterLayout />,
    routes: getRouteObjectList(companyPageIds),
  }),
]